// extracted by mini-css-extract-plugin
module.exports = {"license":"license-module--license--31KCX","license__article":"license-module--license__article--3LjBL"};